import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Flex, HStack, Image, Text, useBreakpointValue, VStack } from '@chakra-ui/react'
import loadingSpinner from 'assets/lottie/loader_wicar.gif'
import { useEngine, usePin, useShareVehicle, useVehicles } from 'context'
import { themeColors } from 'theme'

import { CardContainer } from 'components/CustomCard'
import CustomMaps from 'components/CustomMaps'
import { AddIcon, CarIcon } from 'components/SVGS'

import BuyWicar from './components/BuyWicar'
import SubscriptionInfo from './components/SubscriptionInfo'
import VehicleCard from './components/VehicleCard/index'

export const MyVehicles = () => {
  const { icon: { vehicleSecondaryIconColor } } = themeColors
  const { getVehicles, vehicleState: { loading, state: { vehicles, vehicle } } } = useVehicles()
  const {
    getContactsShareVehicles,
    clearContent,
  } = useShareVehicle()
  const { checkUserPin, clearError, pinState: { error } } = usePin()
  const { getEngineStatus } = useEngine()
  const [isFullMap, setIsFullMap] = useState<boolean>(false)
  const navigate = useNavigate()

  const breakpoint = useBreakpointValue({ base: 'small', md: 'desktop', xl: 'extra-large' })

  const getShareVehicle = useCallback(async () => {
    await clearContent()
    vehicle?.isPremium && vehicle.isOwner && getContactsShareVehicles(vehicle.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle])


  useEffect(() => {
    getShareVehicle()
  }, [getShareVehicle])

  const getStatusEngine = useCallback(async () => {
    vehicle?.isPremium && getEngineStatus(vehicle.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle])

  useEffect(() => {
    getStatusEngine()
  }, [getStatusEngine])


  useEffect(() => {
    if (vehicles.length < 1)
      getVehicles()
    checkUserPin(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  if (loading)
    return (
      <VStack alignItems='center' w='100%'>
        <Image
          w={'120px'}
          h={'120px'}
          alt={'loading_wicar'}
          src={loadingSpinner}
        />
      </VStack>
    )

  if (vehicles.length < 1)
    return (
      <CardContainer isFullScreen>
        <VStack w={{ base: '90%', xl: '50%' }} justifyContent='flex-start' alignItems='center' spacing={4}>
          <CarIcon size={200} fill={vehicleSecondaryIconColor} />
          <Text textAlign='center'>Todavía no has agregado tu vehículo</Text>
          <HStack
          gap={4}
          flexDirection={{ base:'column', xl:'row' }}
          justifyContent='center'
          alignItems="center"
          w="full"
          >
          <Button minW={{ base:280, md:280 }} onClick={() => navigate('/add-vehicle')} leftIcon={<AddIcon size={6} />} variant={'secondary'}>
            Agregar vehículo
          </Button>
          <Button minW={{ base:280, md:280 }} onClick={() => navigate('/new-subscription')} leftIcon={<AddIcon size={6} />} variant={'secondary'}>
            Contratar
          </Button>
          </HStack>
        </VStack>
      </CardContainer>
    )

  return (
    <Flex
      as={breakpoint === 'extra-large' ? HStack : VStack}
      mx='auto'
      w='full'
      mr={2}
      spacing={4}
      alignItems='flex-start'>
      {isFullMap === false && <VehicleCard />}
      <VStack w={{ base: 'full', xl: (isFullMap ? 'full' : '60%') }} spacing={4}>
        {vehicle && vehicle.isPremium && !vehicle.isRestricted &&
          <CardContainer p={0} isFullScreen={isFullMap}>
            <CustomMaps
              height={isFullMap ? 'calc(100vh - 108px)' : 350}
              setIsFullMap={setIsFullMap}
              isFullMap={isFullMap} />
          </CardContainer>
        }
        {(vehicle?.isOwner && isFullMap === false) && <SubscriptionInfo />}
        {isFullMap === false && <BuyWicar />}
      </VStack>
    </Flex>
  )
}
